import { Portal } from '@design/components/portal';
import { EXPANDED_VALUE } from '@terminal/components/expandable-drawer/ExpandableDrawer';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { AlertsInsightCard } from '@terminal/modules/alerts-card/components/alerts-insight-card/AlertsInsightCard';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './TrackingToast.module.scss';

export interface TrackingToastContentProps {
  insightId: string;
}

export const TrackingToastContent = ({
  insightId,
}: TrackingToastContentProps) => {
  const { t } = useTranslation('insights');
  const { params } = useQueryParams();
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );

  const isExpanded = params[queryKeys.drawerExpanded] === EXPANDED_VALUE;
  const relation = params[queryKeys.insightRelation];
  const isSimpleDrawer =
    params[queryKeys.activeDrawer] === queryValues.insightsDrawer;
  const isBannerVisible = isSimpleDrawer && !isBasicOrLightUser && !isExpanded;
  const isNarrowDrawer = isSimpleDrawer && isBasicOrLightUser && !isExpanded;

  return (
    <Portal>
      <div
        className={clsx(styles.toastPositioner, {
          [styles.expanded]: isExpanded,
          [styles.withBanner]: isBannerVisible,
          [styles.narrowDrawer]: isNarrowDrawer,
        })}
      >
        <div className={styles.toastRoot} data-testid="tracking-toast">
          <AlertsInsightCard
            alertEvent={{
              source_id: insightId,
              title: t('insights:drawer.trackingConfirmation'),
              relation: relation ?? undefined,
            }}
            variant="toast"
            compact
          />
        </div>
      </div>
    </Portal>
  );
};
